import arAlerts from "./locales/ar/alerts";
import arAssets from "./locales/ar/assets";
import arAudit from "./locales/ar/audit";
import arAuthentication from "./locales/ar/authentication";
import arButtons from "./locales/ar/buttons";
import arCatalog from "./locales/ar/catalog";
import arCommon from "./locales/ar/common";
import arCompanies from "./locales/ar/companies";
import arDevices from "./locales/ar/devices";
import arGprs from "./locales/ar/gprs";
import arNotifications from "./locales/ar/notifications";
import arPermissions from "./locales/ar/permissions";
import arProfile from "./locales/ar/profile";
import arRoles from "./locales/ar/roles";
import arSensorAssignments from "./locales/ar/sensorAssignments";
import arSubscriptions from "./locales/ar/subscriptions";
import arUserManagement from "./locales/ar/userManagement";
import arUsers from "./locales/ar/users";
import arValidation from "./locales/ar/validation";
import enAlerts from "./locales/en/alerts";
import enAssets from "./locales/en/assets";
import enAudit from "./locales/en/audit";
import enAuthentication from "./locales/en/authentication";
import enButtons from "./locales/en/buttons";
import enCatalog from "./locales/en/catalog";
import enCommon from "./locales/en/common";
import enCompanies from "./locales/en/companies";
import enDevices from "./locales/en/devices";
import enGprs from "./locales/en/gprs";
import enNotifications from "./locales/en/notifications";
import enPermissions from "./locales/en/permissions";
import enProfile from "./locales/en/profile";
import enRoles from "./locales/en/roles";
import enSensorAssignments from "./locales/en/sensorAssignments";
import enSubscriptions from "./locales/en/subscriptions";
import enUserManagement from "./locales/en/userManagement";
import enUsers from "./locales/en/users";
import enValidation from "./locales/en/validation";

export const I18N_NAMESPACES = [
  "alerts",
  "assets",
  "audit",
  "authentication",
  "buttons",
  "catalog",
  "common",
  "companies",
  "devices",
  "gprs",
  "notifications",
  "permissions",
  "profile",
  "roles",
  "sensorAssignments",
  "subscriptions",
  "userManagement",
  "users",
  "validation",
] as const;

export type I18nNamespace = (typeof I18N_NAMESPACES)[number];

export const i18nResources = {
  en: {
    alerts: enAlerts,
    assets: enAssets,
    audit: enAudit,
    authentication: enAuthentication,
    buttons: enButtons,
    catalog: enCatalog,
    common: enCommon,
    companies: enCompanies,
    devices: enDevices,
    gprs: enGprs,
    notifications: enNotifications,
    permissions: enPermissions,
    profile: enProfile,
    roles: enRoles,
    sensorAssignments: enSensorAssignments,
    subscriptions: enSubscriptions,
    userManagement: enUserManagement,
    users: enUsers,
    validation: enValidation,
  },
  ar: {
    alerts: arAlerts,
    assets: arAssets,
    audit: arAudit,
    authentication: arAuthentication,
    buttons: arButtons,
    catalog: arCatalog,
    common: arCommon,
    companies: arCompanies,
    devices: arDevices,
    gprs: arGprs,
    notifications: arNotifications,
    permissions: arPermissions,
    profile: arProfile,
    roles: arRoles,
    sensorAssignments: arSensorAssignments,
    subscriptions: arSubscriptions,
    userManagement: arUserManagement,
    users: arUsers,
    validation: arValidation,
  },
} as const;

const STATIC_NAMESPACE_SET = new Set<string>(I18N_NAMESPACES);

export function isStaticNamespace(namespace: string): boolean {
  return STATIC_NAMESPACE_SET.has(namespace);
}
